import buttonColumn from "@root/tabulator/Services/buttonColumn";
import { stopPropagation } from "@root/tabulator/Services/stopPropagation";
import replaceUrlTags from "@root/services/replaceUrlTags";

export default function link(
    columns, { icon, link, newWindow, condition = null, title = '' }, api, router) {
  columns.push(buttonColumn(
      `link.${link}`,
      icon,
      (e, cell) => {
        stopPropagation(e);
        let url = replaceUrlTags(link, cell.getRow());

        if (newWindow) {
          window.open(url, "_blank");
          return;
        }

        if (url.match(/^https?:\/\//)) {
          window.location.href = url;
          return;
        }

        router.push(url);
      },
      title, (cell) => !condition || cell.getRow().getData()[condition]));
};
